/**
 * Modo de visualización de Registros y del detalle de lista.
 * - `list`: una card por registro (lote, UF o lote CAD), apaisada. Default.
 * - `grid`: dos cards por fila (solo desktop; en pantallas chicas cae a `list`).
 * - `grouped`: agrupado por lote (cards `RegistrosLotCard` / `ListDetailLotCard`).
 * Preferencia del navegador, compartida por los dos paneles.
 */

export const RECORD_VIEW_MODES = Object.freeze({
  LIST: 'list',
  GRID: 'grid',
  GROUPED: 'grouped',
});

export const DEFAULT_RECORD_VIEW_MODE = RECORD_VIEW_MODES.LIST;
export const RECORD_VIEW_MODE_STORAGE_KEY = 'terrio.records.viewMode';

const VALID = new Set(Object.values(RECORD_VIEW_MODES));

/** @param {unknown} value @returns {'list'|'grid'|'grouped'} */
export const normalizeRecordViewMode = (value) => (
  VALID.has(value) ? value : DEFAULT_RECORD_VIEW_MODE
);

/** @returns {'list'|'grid'|'grouped'} */
export function readRecordViewMode() {
  try {
    return normalizeRecordViewMode(window.localStorage.getItem(RECORD_VIEW_MODE_STORAGE_KEY));
  } catch (_) {
    return DEFAULT_RECORD_VIEW_MODE;
  }
}

/** @param {'list'|'grid'|'grouped'} mode */
export function writeRecordViewMode(mode) {
  try {
    window.localStorage.setItem(RECORD_VIEW_MODE_STORAGE_KEY, normalizeRecordViewMode(mode));
  } catch (_) { /* quota / modo privado */ }
}

/**
 * Modo efectivo: la grilla solo si el ancho lo permite.
 * @param {string} mode
 * @param {boolean} canUseGrid
 */
export const resolveEffectiveRecordViewMode = (mode, canUseGrid) => {
  const normalized = normalizeRecordViewMode(mode);
  if (normalized === RECORD_VIEW_MODES.GRID && !canUseGrid) return RECORD_VIEW_MODES.LIST;
  return normalized;
};
